import api from './api';

const tvShowService = {
  // TV Show methods
  async getAllTvShow(params = {}) {
    try {
      const { perPage, currentPage, searchText } = params;
      let url = `/admin/tv_show?perPage=${perPage}&currentPage=${currentPage}`;
      if (searchText) url += `&search=${searchText}`;
      const response = await api.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching TV shows:', error);
      throw error;
    }
  },

  async getSingleTvShow(tvShowId) {
    try {
      const response = await api.get(`/admin/tv_show/${tvShowId}`);
      return response;
    } catch (error) {
      console.error('Error fetching TV show:', error);
      throw error;
    }
  },

  async addTvShow(payload) {
    try {
      const response = await api.post('/admin/tv_show/', payload);
      return response;
    } catch (error) {
      console.error('Error adding TV show:', error);
      throw error;
    }
  },

  async editTvShow(tvShowId, payload) {
    try {
      const response = await api.put(`/admin/tv_show/${tvShowId}`, payload);
      return response;
    } catch (error) {
      console.error('Error editing TV show:', error);
      throw error;
    }
  },

  // TV Show Episode methods
  async getAllTvShowEpisode(params = {}) {
    try {
      const { tv_show_id, season_no, perPage, currentPage, searchText } = params;
      let url = `/admin/tv_show_episode?tv_show_id=${tv_show_id}&season_no=${season_no}&perPage=${perPage}&currentPage=${currentPage}`;
      if (searchText) url += `&search=${searchText}`;
      const response = await api.get(url);
      return response;
    } catch (error) {
      console.error('Error fetching TV show episodes:', error);
      throw error;
    }
  },

  async getSingleTvShowEpisode(episodeId) {
    try {
      const response = await api.get(`/admin/tv_show_episode/${episodeId}`);
      return response;
    } catch (error) {
      console.error('Error fetching TV show episode:', error);
      throw error;
    }
  },

  async addTvShowEpisode(payload) {
    try {
      const response = await api.post('/admin/tv_show_episode', payload);
      return response;
    } catch (error) {
      console.error('Error adding TV show episode:', error);
      throw error;
    }
  },

  async editTvShowEpisode(episodeId, payload) {
    try {
      const response = await api.put(`/admin/tv_show_episode/${episodeId}`, payload);
      return response;
    } catch (error) {
      console.error('Error editing TV show episode:', error);
      throw error;
    }
  },

  // Upload URL
  async getUploadUrl() {
    try {
      const response = await api.get('/admin/get-upload-url');
      return response;
    } catch (error) {
      console.error('Error getting upload URL:', error);
      throw error;
    }
  }
};

export default tvShowService;
